export default __webpack_public_path__ + "static/media/f5.00ccd7e3.jpg";